export default "__VITE_ASSET__7_ME89hs__"